import React, { useState } from "react";

import { Flex, Text, Box, Table } from "flicket-ui";

import { ContentModal } from "~components";
import { formatDate } from "~lib";
import { Row } from "~components/events/events.Row";

type ScheduleProps = {
  events?: any;
  showSchedule?: any;
};

export const Schedule = ({ events, showSchedule }: ScheduleProps) => {
  const [activeEvent, setActiveEvent] = useState({} as any);

  const orderedEvents = events.map(function (event) {
    const timeAsInt = new Date(event.startDate).getTime();
    event.timeAsInt = timeAsInt;
    return event;
  });

  orderedEvents.sort(function (a, b) {
    return a.timeAsInt - b.timeAsInt;
  });

  return (
    <Box w="100%">
      <Flex
        w="100%"
        pb="6/4"
        borderBottom="1px solid"
        borderColor="N200"
        justifyContent="space-between"
        alignItems="center"
        d={{ _: "flex", md: "none !important" }}
      >
        <Text
          lineHeight="medium"
          fontWeight="extraBold"
          fontSize={3}
          color="N800"
        >
          Upcoming Events
        </Text>
      </Flex>
      {showSchedule ? (
        <>
          <Table
            data={orderedEvents}
            row={(props) => (
              <Row
                onClick={() => setActiveEvent(props)}
                disableRedirectToEvent
                bg="white"
                {...props}
              />
            )}
          />
        </>
      ) : (
        <Text
          lineHeight="medium"
          fontWeight="extraBold"
          fontSize={3}
          color="N800"
          textAlign={"center"}
        >
          Schedule coming soon!
        </Text>
      )}
      <ContentModal
        isOpen={!!activeEvent?.title}
        setIsOpen={() => setActiveEvent({})}
        title={activeEvent?.title}
        image={activeEvent?.logo}
        richText={activeEvent?.description}
        subtitle={activeEvent?.venue?.name}
        location={activeEvent?.venue?.name}
        date={
          activeEvent?.endDate &&
          formatDate(activeEvent?.startDate, "dd") !==
            formatDate(activeEvent.endDate, "dd")
            ? `${formatDate(
                activeEvent?.startDate,
                "dd LLL yyyy"
              )} - ${formatDate(activeEvent?.endDate, "dd LLL yyyy")}`
            : formatDate(activeEvent?.startDate, "E, dd LLL yyyy p")
        }
      />
    </Box>
  );
};
